/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import { useCallback, useEffect, useRef } from "react";

const getElement = (): HTMLElement => {
  let element = document.getElementById("report-container");

  if (element === null) {
    element = document.createElement("div");
    element.id = "report-container";
    element.style.position = "absolute";
    element.style.top = "-0.25rem";
    element.style.left = "-0.25rem";
    element.style.fontSize = "1rem";
    element.style.padding = "0";
    element.style.backgroundColor = "darkgrey";
    element.style.padding = "0.5rem";
    element.style.borderRadius = "0.5rem";
    element.style.color = "white";
    element.style.fontWeight = "700";
    element.style.maxWidth = "100%";
    element.style.maxHeight = "2.25rem";
    element.style.opacity = "1";
    element.style.zIndex = "1000000";
    element.style.whiteSpace = "nowrap";
    element.style.overflow = "hidden";
    element.style.textOverflow = "ellipsis";

    if (document.body) {
      const editorUltra = document.getElementById("editor-ultra");

      if (editorUltra) {
        editorUltra.appendChild(element);
      }
    }
  }

  return element;
};

export default function useReport(): (
  arg0: string
) => ReturnType<typeof setTimeout> {
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const cleanup = useCallback(() => {
    if (timer !== null) {
      clearTimeout(timer.current as ReturnType<typeof setTimeout>);
    }

    if (document.body) {
      const editorUltra = document.getElementById("editor-ultra");

      if (editorUltra) {
        editorUltra.removeChild(getElement());
      }
    }
  }, []);

  useEffect(() => {
    return cleanup;
  }, [cleanup]);

  return useCallback(
    (content) => {
      // eslint-disable-next-line no-console
      const element = getElement();
      clearTimeout(timer.current as ReturnType<typeof setTimeout>);
      element.innerHTML = content;
      timer.current = setTimeout(cleanup, 1000);
      return timer.current;
    },
    [cleanup]
  );
}
